import {
  LogoSmall as LogoSmallIcon,
  LogoMain as LogoMainIcon,
  Billing as BillingIcon,
  Location as LocationIcon,
  Property,
  NavStudentIcon,
  ContractCMS as ContractIcon,
  IconReconciliation as IconReconciliationIcon,
  AccountIconCMS as AccountIconIcon,
  NavReferral as NavReferralIcon,
  Schedule as BookingIcon,
  ReadOutlined,
  IconMarketing,
  PmsIcon,
  Strategy,
  Landlord,
} from 'common/components/svgs';
import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, Menu, message, Spin } from 'antd';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import cookies from 'js-cookie';
import Header from '~components/header';
import PropertyList from '~pages/dashboard/properties';
import LandlordManagement from '~pages/dashboard/landlord';
import { onlyViewPropertyRole } from '~client/helpers/auth';
import PaymentDashboard from '~pages/dashboard/payment';
import LandlordDetails from '~client/pages/dashboard/landlord/details';
import PendingApproveList from '~pages/dashboard/pending-approve/list';
import PropertyListingManagement from '~pages/dashboard/properties/listing-management';
import PropertyCommission from '~pages/dashboard/properties/commission';
import PropertyDepositAndFees from '~pages/dashboard/properties/deposit-and-fees';
import ReferenceAndContact from '~pages/dashboard/properties/reference-and-contact';
import PropertyCreate from '~pages/dashboard/properties/create';
import PropertyRecord from '~pages/dashboard/properties/record';
import PropertyTerms from '~pages/dashboard/properties/terms';
import SpecialOffer from '~pages/dashboard/special-offer/index';
import CreateOffer from '~pages/dashboard/special-offer/create-offer';
import EditOffer from '~pages/dashboard/special-offer/edit-offer';
import Notification from '@pages/dashboard/notification';
import Constructing from '~pages/dashboard/constructing';
import { logout, getUserAuth, setSelectRole } from '~actions/auth';
import { fireCustomEvent } from '~helpers/custom-events';
import generatePath from '~settings/routing';
import Country from '~pages/dashboard/location/country/index';
import CityEdit from '~pages/dashboard/location/city/edit';
import UniversityEdit from '~pages/dashboard/location/university/edit';
import PropertyHomepage from '~pages/dashboard/properties/homepage';
import City from '~pages/dashboard/location/city/index';
import University from '~pages/dashboard/location/university/index';
import Account from '~pages/dashboard/account';
import Billing from '~pages/dashboard/billing';
import PMSIntegrations from '~pages/dashboard/pms-integrations';
import PMSDetails from '~pages/dashboard/pms-integrations/pms-details';
import BillingTransferList from '~pages/dashboard/billing/transfer';
import BillingTransferDetails from '~pages/dashboard/billing/transfer/details';
import BillingReceiveList from '~pages/dashboard/billing/receive';
import BillingReceiveDetails from '~pages/dashboard/billing/receive/details';
import BillingRefundList from '~pages/dashboard/billing/refund';
import BillingRefundDetails from '~pages/dashboard/billing/refund/details';
import Reviews from '~pages/dashboard/reviews';
import Contract from '~pages/dashboard/contract/index';
import Booking from '~pages/dashboard/booking/index';
import Tags from '~pages/dashboard/tags/index';
import StrategyPage from '~pages/dashboard/strategy';
import StrategyCityHomepage from '~pages/dashboard/strategy/city-homepage';
import StrategyHomepageSettingPage from '~pages/dashboard/strategy/homepage-setting';
import StrategyHeroBanner from '~pages/dashboard/strategy/hero-banner';

import showElementByAuth, {
  isRegionalSupplyHeadRole,
  showLandlordManaging,
  isInternalRole,
  isLandlordRole,
  isFinancialRole,
  isSupplyRole,
  isAdminRole,
  isContentSupervisorRole,
  isContentSpecialistRole,
  isUserRole,
  isBDRole,
  isBCRole,
} from '~helpers/auth';
import ChangeLog from '~pages/dashboard/properties/change-log';
import ListingManagement from '~pages/dashboard/properties/change-log/listing-management';
import CommissionManagement from '~pages/dashboard/properties/change-log/commission-management';
import ContractRecord from '~pages/dashboard/properties/change-log/contract-record';
import PolicySetting from '~pages/dashboard/properties/change-log/policy-setting';
import DepositAndFees from '~pages/dashboard/properties/change-log/deposit-and-fees';

import { handleSwitchRoleRedirect } from '~client/components/switch-role/useSwitchRole';
import { platformEntity, entityAction, cookieNames } from '~constants/index';
import { getItem } from '~helpers/storage';
import SwitchRolePage from '~client/components/switch-role/page';
import SwitchRoleModal from '~client/components/switch-role/modal';
import * as accountActions from '~actions/account';
import BasicSetting from '~pages/dashboard/account/basic-setting';
import Reconciliation from '~pages/dashboard/reconciliation';
import ReconciliationOrder from '~pages/dashboard/reconciliation/order';
import OrderDetail from '~pages/dashboard/reconciliation/order/detail';
import ReconciliationBookingDetails from '~pages/dashboard/reconciliation/booking-details';
import CommissionPlan from '~pages/dashboard/referral/commission-plan';
import PayoutPlan from '~pages/dashboard/referral/payout-plan';
import PromotionPage from '~pages/dashboard/referral/promotion';
import PartnerPage from '~pages/dashboard/referral/partner';
import PartnerDetails from '~pages/dashboard/referral/partner/partner-detail';
import PartnerAccountPage from '~pages/dashboard/referral/partner-account';
import PartnerAccountDetails from '~pages/dashboard/referral/partner-account/detail';
import PayoutPage from '~pages/dashboard/referral/payout';
import DashboardRelease from '~pages/dashboard/content/dashboard-release';
import MessagePropertyDetail from '~pages/dashboard/booking/message-property-detail';
import ManualPropertyDetail from '~pages/dashboard/booking/manual-detail';
import Article from '@pages/dashboard/content/article';
import TransferPage from '~pages/dashboard/referral/transfer';
const StudentPage = lazy(() => import('~pages/dashboard/students/list'));
const StudentDetail = lazy(() => import('~pages/dashboard/students/student-detail'));
import { Hosts } from '~helpers/environments';
import BookingDetail from './booking/booking-detail';

const mapStateToProps = state => ({
  token: state.auth.getIn(['base', 'token']),
  role: state.auth.getIn(['base', 'role']),
  currentRoleSlug: state.auth.get('auth').currentRoleSlug,
  cmsUser: state.dashboard.account?.toJS().account,
  cmsUserCommunication: state.dashboard.account?.toJS().communication?.getCmsUser,
  authInfoCommunication: state.auth.get('getAuthInfo').toJS()?.communication,
});

const mapDispatchToProps = dispatch => ({
  logoutUser: () => {
    dispatch(logout());
  },
  getUserAuth: (onSuccess, token) => {
    dispatch(getUserAuth(onSuccess, token));
  },
  setSelectRole: payload => {
    dispatch(setSelectRole(payload));
  },
  getCmsUser: onSuccess => {
    dispatch(accountActions.getCmsUser(onSuccess));
  },
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      nowTab: this.props.location.pathname,
      showSwitchRolePage: false,
      showSwitchRoleModal: false,
      automaticCloseMenu: true,
      isFetching: true,
    };

    this.locationType = ['countries', 'cities', 'universities'];
    this.marketingType = ['special-offers', 'reviews', 'tags'];
    this.locationEntityMapping = {
      countries: platformEntity.LOCATIONS_COUNTRIES,
      cities: platformEntity.LOCATIONS_CITIES,
      universities: platformEntity.UNIVERSITIES_UNIVERSITIES,
    };
    this.customSidebar = false;
  }

  componentDidMount() {
    this.handleUserAuth();
    message.config({
      maxCount: 1,
    });
    window.addEventListener('resize', this.packUpMenu);
    window.addEventListener('triggerSwitchRole', this.handleSwitchRole);
    window.addEventListener('triggerCloseMenu', this.closeMenu);
    this.packUpMenu();

    const { pathname } = this.props.location;
    if (pathname.includes('account/account-management') && !showLandlordManaging()) {
      this.props.history.push(generatePath('myProfile', {}));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.packUpMenu);
    window.removeEventListener('triggerSwitchRole', this.handleSwitchRole);
    window.removeEventListener('triggerCloseMenu', this.closeMenu);
  }

  handleCloseSwitchRolePage = () => {
    this.setState({
      showSwitchRolePage: false,
    });
  };

  handleCloseSwitchRoleModal = () => {
    this.setState({
      showSwitchRoleModal: false,
    });
  };

  handleSwitchRole = () => {
    this.setState({
      showSwitchRoleModal: true,
    });
  };

  handleUserAuth = () => {
    const auth = getItem('PMS_CURRENT_USER_AUTH');
    const cookieToken = cookies.get(cookieNames.token);

    if (!auth || auth.authToken !== cookieToken) {
      this.props.getCmsUser(res => {
        if (res?.cmsUser?.userRoles?.length > 1) {
          this.setState({ showSwitchRolePage: true, isFetching: false });
        } else {
          this.props.getUserAuth(result => {
            const role = result?.identity?.identity?.frontendScopes?.[0]?.role;

            handleSwitchRoleRedirect(this.props.history, this.props.location?.pathname, role);

            this.setState({
              isFetching: false,
            });
          }, cookieToken);
        }
      });
    } else if (!this.props.cmsUser?.userRoles?.length) {
      this.props.getCmsUser();
      this.props.setSelectRole(auth.payload);
      this.setState({ showSwitchRolePage: false, isFetching: false });
    } else {
      this.setState({ showSwitchRolePage: false, isFetching: false });
    }
  };

  packUpMenu = () => {
    const windowWidth = document.body.clientWidth;
    const pendingApprove = document.querySelector('.pending-approve');
    const pendingApproveWidth = pendingApprove ? pendingApprove.clientWidth : 0;

    if (windowWidth - pendingApproveWidth <= 924 && !this.state.collapsed && !this.customSidebar) {
      this.setState({ collapsed: true });
    }

    if (windowWidth - pendingApproveWidth > 924 && this.state.collapsed && !this.customSidebar) {
      this.setState({ collapsed: false });
    }
  };

  closeMenu = () => {
    if (this.state.automaticCloseMenu) {
      this.setState({
        collapsed: true,
        automaticCloseMenu: false,
      });
    }
  };

  toggleCollapseSidebar = () => {
    this.customSidebar = true;
    this.setState({
      collapsed: !this.state.collapsed,
    });

    setTimeout(() => {
      fireCustomEvent('toggleCollapseSidebarTriggers');
    }, 200);
  };

  getSelectTab = () => {
    const { pathname } = this.props.location;

    const selectNavList = [
      'bookings',
      'booking',
      'contract',
      'billing',
      'reconciliation',
      'agent',
      'pms-integrations',
      'strategy',
    ]
      .map(item => {
        if (pathname.includes(item)) {
          return item;
        }
      })
      ?.filter(item => item);

    if (this.props.currentRoleSlug === 'agent_admin') {
      return 'agent';
    }
    if (pathname.includes('properties') || pathname.includes('property')) {
      return 'properties';
    }
    if (pathname.includes('landlords') || pathname.includes('landlord')) {
      if (!pathname.includes('reconciliation/landlord')) {
        return 'landlords';
      }
    }
    if (pathname.includes('marketing/special-offers')) {
      return 'special-offers';
    }
    if (pathname.includes('marketing/reviews')) {
      return 'reviews';
    }
    if (pathname.includes('marketing/tags')) {
      return 'tags';
    }
    if (pathname.includes('locations/countries')) {
      return 'countries';
    }
    if (pathname.includes('locations/universities') || pathname.includes('locations/university')) {
      return 'universities';
    }
    if (pathname.includes('locations/cities') || pathname.includes('locations/city')) {
      return 'cities';
    }

    if (pathname.includes('account/my-profile')) {
      return 'my-profile';
    }

    if (pathname.includes('account/account-management')) {
      return 'account-management';
    }

    if (pathname.includes('referral/commission-plan')) {
      return 'commission-plan';
    }

    if (pathname.includes('referral/payout-plan')) {
      return 'payout-plan';
    }

    if (pathname.includes('referral/promotion')) {
      return 'promotion';
    }

    if (pathname.includes('referral/partner') && !pathname.includes('referral/partner-account')) {
      return 'partner';
    }
    if (pathname.includes('referral/partner-account')) {
      return 'partner-account';
    }

    if (pathname.includes('referral/payout')) {
      return 'payout';
    }

    if (pathname.includes('reconciliation/booking-with-consultant')) {
      return 'booking-with-consultant';
    }

    if (pathname.includes('reconciliation/order')) {
      return 'order';
    }

    if (pathname.includes('content/dashboard-release')) {
      return 'dashboard-release';
    }

    if (pathname.includes('content/article')) {
      return 'article';
    }

    if (pathname.includes('referral/transfer')) {
      return 'transfer';
    }

    if (pathname.includes('marketing/notification')) {
      return 'notification';
    }

    if (pathname.includes('students')) {
      return 'students';
    }

    if (selectNavList?.length) {
      return selectNavList[0];
    }
  };

  isNoContentMarginPage = () => {
    const { pathname } = this.props.location;

    if (
      [
        '/homepage',
        '/commission',
        '/deposit-and-fees',
        '/landlord/',
        '/billing',
        '/reconciliation',
        '/referral',
        '/booking',
        '/notification',
        '/students',
      ].some(item => pathname.includes(item)) ||
      (pathname.includes('/property/') && !pathname.includes('/create')) ||
      pathname.includes('/special-offers/edit')
    ) {
      return true;
    }

    return false;
  };

  getDefaultOpenKeys = tab => {
    if (this.marketingType.includes(tab)) {
      return ['marketing'];
    }
    if (this.locationType.includes(tab)) {
      return ['location'];
    } else if (['my-profile', 'account-management'].includes(tab)) {
      return ['account'];
    } else if (
      [
        'commission-plan',
        'promotion',
        'payout-plan',
        'payout',
        'partner',
        'partner-account',
      ].includes(tab)
    ) {
      return ['referral'];
    } else if (['booking-with-consultant', 'order'].includes(tab)) {
      return ['reconciliation'];
    } else if (['dashboard-release', 'article'].includes(tab)) {
      return ['content'];
    } else if (['special-offers', 'reviews', 'tags', 'notification'].includes(tab)) {
      return ['marketing'];
    }
    if ('students' === tab) {
      return ['students'];
    }
    if ('agent' === tab) {
      return ['agent_admin'];
    } else {
      return [''];
    }
  };

  render() {
    const { Content, Sider } = Layout;
    const tab = this.getSelectTab();

    const { token } = this.props;

    if (!token || token.length === 0) {
      return <Redirect to={generatePath('login', {})} />;
    }

    if (this.state.isFetching) {
      return <Spin />;
    }
    return (
      <Layout className="dashboard">
        <Sider
          collapsible={false}
          collapsed={this.state.collapsed}
          width={this.state.collapsed ? '64' : '200'}
          trigger="null"
          className={classNames('sidebar', {
            'sidebar--collapsed': this.state.collapsed,
          })}
        >
          <div className="sidebar__logo-container">
            <If condition={this.state.collapsed}>
              <LogoSmallIcon className="sidebar__logo-small" />
            </If>
            <If condition={!this.state.collapsed}>
              <LogoMainIcon className="sidebar__logo" />
            </If>
          </div>
          <Menu
            theme="dark"
            mode={this.state.collapsed ? 'vertical' : 'inline'}
            selectedKeys={[tab]}
            defaultOpenKeys={this.getDefaultOpenKeys(tab)}
            className="sidebar__menu"
          >
            <If
              condition={
                isBCRole() ||
                showElementByAuth(platformEntity.PROPERTIES_PROPERTIES, entityAction.READ)
              }
            >
              <Menu.Item
                key="properties"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.properties')}
              >
                <Link to="/properties" className="sidebar__menu__link">
                  <Property className="sidebar__icon sidebar__icon--property" hash="property" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.properties')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If
              condition={showElementByAuth(platformEntity.LANDLORDS_LANDLORDS, entityAction.READ)}
            >
              <Menu.Item
                key="landlords"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.landlord')}
              >
                <Link to="/landlords" className="sidebar__menu__link">
                  <Landlord className="sidebar__icon sidebar__icon--property" hash="landlord" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.landlord')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If condition={isAdminRole() || isBDRole() || isBCRole()}>
              <Menu.Item
                key="students"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.students')}
              >
                <Link to="/students" className="sidebar__menu__link">
                  <NavStudentIcon className="sidebar__icon" />
                  <span className="sidebar__text">{this.props.t('cms.sidebar.menu.students')}</span>
                </Link>
              </Menu.Item>
            </If>
            <If
              condition={
                isAdminRole() ||
                isSupplyRole() ||
                isRegionalSupplyHeadRole() ||
                isBCRole() ||
                isBDRole()
              }
            >
              <Menu.Item
                key="booking"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.booking')}
              >
                <Link to="/booking" className="sidebar__menu__link sidebar__menu__bookinglink ">
                  <BookingIcon className="sidebar__icon" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.booking')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If
              condition={showElementByAuth(platformEntity.PROPERTIES_CONTRACTS, entityAction.READ)}
            >
              <Menu.Item
                key="contract"
                title={this.props.t('cms.sidebar.menu.contract')}
                className="sidebar__menu__item"
              >
                <Link to="/contract" className="sidebar__menu__link">
                  <ContractIcon className="sidebar__icon" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.contract')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If
              condition={
                isAdminRole() ||
                isContentSpecialistRole() ||
                isContentSupervisorRole() ||
                showElementByAuth(
                  platformEntity.SPECIAL_OFFERS_SPECIAL_OFFERS,
                  entityAction.READ,
                ) ||
                (!isLandlordRole() &&
                  showElementByAuth(platformEntity.REVIEWS_REVIEWS, entityAction.READ))
              }
            >
              <Menu.SubMenu
                key="marketing"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <IconMarketing className="sidebar__icon" style={{ fontSize: 16 }} />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.marketing')}
                    </span>
                  </span>
                }
              >
                <If
                  condition={showElementByAuth(
                    platformEntity.SPECIAL_OFFERS_SPECIAL_OFFERS,
                    entityAction.READ,
                  )}
                >
                  <Menu.Item key="special-offers" className="sidebar__locale-menu">
                    <Link to="/marketing/special-offers">
                      <span className="sidebar__text">
                        {this.props.t('cms.sidebar.menu.special_offers')}
                      </span>
                    </Link>
                  </Menu.Item>
                </If>

                <If
                  condition={
                    !isLandlordRole() &&
                    showElementByAuth(platformEntity.REVIEWS_REVIEWS, entityAction.READ)
                  }
                >
                  <Menu.Item key="reviews" className="sidebar__locale-menu">
                    <Link to="/marketing/reviews">
                      <span className="sidebar__text">
                        {this.props.t('cms.sidebar.menu.reviews')}
                      </span>
                    </Link>
                  </Menu.Item>
                </If>

                <If
                  condition={
                    (isContentSpecialistRole() ||
                      isContentSupervisorRole() ||
                      isAdminRole() ||
                      isRegionalSupplyHeadRole() ||
                      isSupplyRole()) &&
                    showElementByAuth(
                      platformEntity.SPECIAL_OFFERS_SPECIAL_OFFERS,
                      entityAction.READ,
                    )
                  }
                >
                  <Menu.Item key="tags" className="sidebar__locale-menu">
                    <Link to="/marketing/tags">
                      <span className="sidebar__text">{this.props.t('cms.sidebar.menu.tags')}</span>
                    </Link>
                  </Menu.Item>
                </If>

                <If
                  condition={
                    isAdminRole() || isContentSpecialistRole() || isContentSupervisorRole()
                  }
                >
                  <Menu.Item key="notification" className="sidebar__locale-menu">
                    <Link to="/marketing/notification">
                      <span className="sidebar__text">
                        {this.props.t('cms.sidebar.menu.notification')}
                      </span>
                    </Link>
                  </Menu.Item>
                </If>
              </Menu.SubMenu>
            </If>

            <If
              condition={
                showElementByAuth(platformEntity.ORDER_TRANSFERS, entityAction.READ) ||
                showElementByAuth(platformEntity.ORDER_RECEIVES, entityAction.READ) ||
                showElementByAuth(platformEntity.ORDER_REFUNDS, entityAction.READ)
              }
            >
              <Menu.Item
                key="billing"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.billing')}
              >
                <Link to="/billing" className="sidebar__menu__link">
                  <BillingIcon className="sidebar__icon" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.billing')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If
              condition={
                isInternalRole() &&
                !isFinancialRole() &&
                !isUserRole('agent_admin') &&
                !isBCRole() &&
                !isBDRole()
              }
            >
              <Menu.SubMenu
                key="location"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <LocationIcon className="sidebar__icon" />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.location')}
                    </span>
                  </span>
                }
              >
                <For of={this.locationType} each="type" index="index">
                  <If
                    condition={showElementByAuth(
                      this.locationEntityMapping[type],
                      entityAction.READ,
                    )}
                  >
                    <Menu.Item key={type} className="sidebar__locale-menu">
                      <Link to={`/locations/${type}`}>
                        <span className="sidebar__text">
                          {this.props.t(`cms.sidebar.menu.location.${type}`)}
                        </span>
                      </Link>
                    </Menu.Item>
                  </If>
                </For>
              </Menu.SubMenu>
            </If>
            <If condition={isAdminRole() || isSupplyRole() || isRegionalSupplyHeadRole()}>
              <Menu.Item
                key="pms-integrations"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.pms_integrations')}
              >
                <Link to="/pms-integrations" className="sidebar__menu__link">
                  <PmsIcon className="sidebar__icon" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.pms_integrations')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>
            <If condition={!isBCRole() && !isBDRole()}>
              <Menu.Item
                key="strategy"
                className="sidebar__menu__item"
                title={this.props.t('cms.sidebar.menu.strategy')}
              >
                <Link to="/strategy" className="sidebar__menu__link">
                  <Strategy className="sidebar__icon" />
                  <If condition={!this.state.collapsed}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.strategy')}
                    </span>
                  </If>
                </Link>
              </Menu.Item>
            </If>

            <If
              condition={
                isSupplyRole() ||
                isAdminRole() ||
                isRegionalSupplyHeadRole() ||
                isContentSupervisorRole() ||
                isFinancialRole()
              }
            >
              <Menu.SubMenu
                key="reconciliation"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <IconReconciliationIcon className="sidebar__icon sidebar__icon--reconciliation" />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.reconciliation')}
                    </span>
                  </span>
                }
              >
                <Menu.Item key="booking-with-consultant" className="sidebar__locale-menu">
                  <Link to={'/reconciliation/booking-with-consultant'}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.reconciliation.booking_with_consultant')}
                    </span>
                  </Link>
                </Menu.Item>

                <If condition={(showLandlordManaging() && !isBDRole()) || isFinancialRole()}>
                  <Menu.Item key="order" className="sidebar__locale-menu">
                    <Link to={'/reconciliation/order'}>
                      <span className="sidebar__text">
                        {this.props.t('cms.sidebar.menu.reconciliation.lead_generation')}
                      </span>
                    </Link>
                  </Menu.Item>
                </If>
              </Menu.SubMenu>
            </If>
            <If condition={isAdminRole() || isBDRole()}>
              <Menu.SubMenu
                key="referral"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <NavReferralIcon className="sidebar__icon" />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral')}
                    </span>
                  </span>
                }
              >
                <Menu.Item key="partner-account" className="sidebar__locale-menu">
                  <Link to="/referral/partner-account">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.partner_account')}
                    </span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="partner" className="sidebar__locale-menu">
                  <Link to="/referral/partner">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.partner')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="commission-plan" className="sidebar__locale-menu">
                  <Link to="/referral/commission-plan">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.commission_plan')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="promotion" className="sidebar__locale-menu">
                  <Link to="/referral/promotion">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.promotion')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="payout-plan" className="sidebar__locale-menu">
                  <Link to="/referral/payout-plan">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.payout_plan')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="payout" className="sidebar__locale-menu">
                  <Link to="/referral/payout">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.payout')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="transfer" className="sidebar__locale-menu">
                  <Link to="/referral/transfer">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.referral.transfer')}
                    </span>
                  </Link>
                </Menu.Item>
              </Menu.SubMenu>
            </If>
            <If condition={isAdminRole()}>
              <Menu.SubMenu
                key="content"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <ReadOutlined className="sidebar__icon" />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.content')}
                    </span>
                  </span>
                }
              >
                <Menu.Item key="dashboard-release" className="sidebar__locale-menu">
                  <Link to="/content/dashboard-release">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.content.dashboard_release')}
                    </span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="article" className="sidebar__locale-menu">
                  <Link to="/content/article">
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.content.article')}
                    </span>
                  </Link>
                </Menu.Item>
              </Menu.SubMenu>
            </If>
            <If
              condition={
                showElementByAuth(platformEntity.IDENTITY_CMS_USERS, entityAction.READ) &&
                !isUserRole('agent_admin')
              }
            >
              <Menu.SubMenu
                key="account"
                className="sidebar__submenu"
                title={
                  <span className={'sidebar__label-container'}>
                    <AccountIconIcon className="sidebar__icon" />
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.account')}
                    </span>
                  </span>
                }
              >
                <Menu.Item key="my-profile" className="sidebar__locale-menu">
                  <Link to={'/account/my-profile'}>
                    <span className="sidebar__text">
                      {this.props.t('cms.sidebar.menu.account.my_profile')}
                    </span>
                  </Link>
                </Menu.Item>
                <If
                  condition={
                    showLandlordManaging() && !isFinancialRole() && !isBDRole() && !isBCRole()
                  }
                >
                  <Menu.Item key="account-management" className="sidebar__locale-menu">
                    <Link to={'/account/account-management'}>
                      <span className="sidebar__text">
                        {this.props.t('cms.sidebar.menu.account.account_management')}
                      </span>
                    </Link>
                  </Menu.Item>
                </If>
              </Menu.SubMenu>
            </If>
            <If condition={isUserRole('agent_admin') || isAdminRole()}>
              <Menu.SubMenu
                key="agent_admin"
                className="sidebar__submenu"
                selectedKeys={[tab]}
                defaultOpenKeys={this.getDefaultOpenKeys(tab)}
                title={
                  <span className={'sidebar__label-container'}>
                    <AccountIconIcon className="sidebar__icon" />
                    <span className="sidebar__text">Agent</span>
                  </span>
                }
              >
                {[
                  { name: 'Moderation', url: 'moderation/service-categories' },
                  {
                    name: 'KYC Verification',
                    url: 'kyc-verification',
                  },
                ].map(item => (
                  <Menu.Item key={`agent-${item.name}`} className="sidebar__locale-menu">
                    <a href={`${Hosts.agentUrl}/${item.url}`} target={'_blank'} rel="noreferrer">
                      <span className="sidebar__text">{item.name}</span>
                    </a>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            </If>
          </Menu>
        </Sider>
        <Layout className="dashboard__layout">
          <Header
            t={this.props.t}
            cmsUser={this.props.cmsUser}
            collapsed={this.state.collapsed}
            toggleCollapseSidebar={this.toggleCollapseSidebar}
            location={this.props.location}
            history={this.props.history}
            currentRoleSlug={this.props.currentRoleSlug}
            logoutUser={this.props.logoutUser}
          />
          <Content
            className={classNames('dashboard__content', {
              'dashboard__content--properties': this.props.location.pathname === '/properties',
              'dashboard__content--no-margin': this.isNoContentMarginPage(),
            })}
          >
            <Switch>
              <Route path={'/marketing/reviews'} exact component={Reviews} />
              <Route path={'/bookings'} exact component={Constructing} />
              <Route path={'/properties'} exact component={PropertyList} />
              <Route
                path={'/property/:propertySlug/edit'}
                exact
                component={PropertyListingManagement}
              />
              <Route path={'/property/:propertySlug/homepage'} exact component={PropertyHomepage} />
              <Route
                path={'/property/:propertySlug/commission'}
                exact
                component={PropertyCommission}
              />
              <Route path={'/property/:propertySlug/record'} exact component={PropertyRecord} />
              <Route
                path={'/property/:propertySlug/deposit-and-fees'}
                exact
                component={PropertyDepositAndFees}
              />
              <Route path={'/property/:propertySlug/terms'} exact component={PropertyTerms} />
              <Route path={'/property/:propertySlug/change-log'} exact component={ChangeLog} />
              <Route
                path={'/property/:propertySlug/change-log/listing-management'}
                exact
                component={ListingManagement}
              />
              <Route
                path={'/property/:propertySlug/change-log/commission-management'}
                exact
                component={CommissionManagement}
              />
              <Route
                path={'/property/:propertySlug/change-log/contract-record'}
                exact
                component={ContractRecord}
              />
              <Route
                path={'/property/:propertySlug/change-log/policy-setting'}
                exact
                component={PolicySetting}
              />
              <Route
                path={'/property/:propertySlug/change-log/deposit-and-fees'}
                exact
                component={DepositAndFees}
              />
              <Route
                path={'/property/:propertySlug/reference-and-contact'}
                exact
                component={ReferenceAndContact}
              />
              <Route path={'/property/create'} exact component={PropertyCreate} />
              <Route path={'/landlords'} exact component={LandlordManagement} />
              <Route path={'/landlord/:landlordSlug'} exact component={LandlordDetails} />
              <Route
                path={'/landlord/:landlordSlug/payment/list'}
                exact
                component={LandlordDetails}
              />
              <Route path={'/landlord/:landlordSlug/payment'} component={PaymentDashboard} />
              <Route path={'/marketing/special-offers'} exact component={SpecialOffer} />
              <Route path={'/marketing/special-offers/create'} exact component={CreateOffer} />
              <Route path={'/marketing/special-offers/edit/:id'} exact component={EditOffer} />
              <Route path={'/marketing/tags'} exact component={Tags} />
              <Route path={'/marketing/notification'} exact component={Notification} />
              <Route path={'/locations/countries'} exact component={Country} />
              <Route path={'/locations/cities'} exact component={City} />
              <Route path={'/locations/universities'} exact component={University} />
              <Route path={'/locations/city/:slug/edit'} exact component={CityEdit} />
              <Route path={'/locations/university/:slug/edit'} exact component={UniversityEdit} />
              <Route path={'/account/my-profile'} exact component={BasicSetting} />
              <Route path={'/account/account-management'} exact component={Account} />
              <Route path={'/contract'} exact component={Contract} />
              <Route path={'/booking'} exact component={Booking} />
              <Route path={'/pms-integrations'} exact component={PMSIntegrations} />
              <Route path={'/pms-integrations/details/:id'} exact component={PMSDetails} />
              <Route path={'/billing'} exact component={Billing} />
              <Route path={'/billing/transfers'} exact component={BillingTransferList} />
              <Route
                path={'/billing/transfer/:id/detail'}
                exact
                component={BillingTransferDetails}
              />
              <Route path={'/billing/receivables'} exact component={BillingReceiveList} />
              <Route path={'/billing/receive/:id/detail'} exact component={BillingReceiveDetails} />
              <Route path={'/billing/refunds'} exact component={BillingRefundList} />
              <Route path={'/billing/refund/:id/detail'} exact component={BillingRefundDetails} />
              <Route
                path={'/reconciliation/booking-with-consultant'}
                exact
                component={Reconciliation}
              />

              <Route path={'/reconciliation/order'} exact component={ReconciliationOrder} />
              {/* <Route
                path={'/reconciliation/landlord/:id'}
                exact
                component={ReconciliationLandlord}
              /> */}
              <Route
                path={'/reconciliation/booking-with-consultant/:opportunityId'}
                exact
                component={ReconciliationBookingDetails}
              />
              <Route path={'/reconciliation/order/:id/detail'} exact component={OrderDetail} />
              <Route path={'/referral/commission-plan'} exact component={CommissionPlan} />
              <Route path={'/referral/payout-plan'} exact component={PayoutPlan} />
              <Route path={'/referral/promotion'} exact component={PromotionPage} />
              <Route path={'/referral/partner'} exact component={PartnerPage} />
              <Route path={'/referral/partner/:id/detail'} exact component={PartnerDetails} />
              <Route path={'/referral/partner-account'} exact component={PartnerAccountPage} />
              <Route
                path={'/referral/partner-account/:id/detail'}
                exact
                component={PartnerAccountDetails}
              />
              <Route path={'/referral/payout'} exact component={PayoutPage} />
              <Route path={'/content/dashboard-release'} exact component={DashboardRelease} />
              <Route path={'/content/article'} exact component={Article} />
              <Route path={'/booking/:id/detail'} exact component={MessagePropertyDetail} />
              <Route path={'/booking/:id/manual-detail'} exact component={ManualPropertyDetail} />
              <Route path={'/booking/:id/:bookingJourney/detail'} exact component={BookingDetail} />
              <Route path={'/referral/transfer'} exact component={TransferPage} />
              <Route path={'/strategy'} exact component={StrategyPage} />
              <Route path={'/strategy/:name'} exact component={StrategyCityHomepage} />
              <Route
                path={'/strategy/:name/homepage'}
                exact
                component={StrategyHomepageSettingPage}
              />
              <Route path={'/strategy/:name/hero-banner'} exact component={StrategyHeroBanner} />
              <Route path={'/students'} exact component={StudentPage} />
              <Route path={'/students/:id/detail'} exact component={StudentDetail} />
            </Switch>
            <If
              condition={this.props.location.pathname === '/properties' && !onlyViewPropertyRole()}
            >
              <div className="dashboard__pending-approve">
                <PendingApproveList showSwitchRoleModal={this.state.showSwitchRolePage} />
              </div>
            </If>
          </Content>
        </Layout>
        <If condition={this.state.showSwitchRolePage}>
          <SwitchRolePage
            activeModal={this.state.showSwitchRolePage}
            onClose={this.handleCloseSwitchRolePage}
            t={this.props.t}
          />
        </If>
        <If condition={this.state.showSwitchRoleModal}>
          <SwitchRoleModal
            activeModal={this.state.showSwitchRoleModal}
            onClose={this.handleCloseSwitchRoleModal}
            t={this.props.t}
            history={this.props.history}
            location={this.props.location}
          />
        </If>
      </Layout>
    );
  }
}

Dashboard.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  token: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  getUserAuth: PropTypes.func.isRequired,
  getCmsUser: PropTypes.func.isRequired,
  setSelectRole: PropTypes.func.isRequired,
  currentRoleSlug: PropTypes.string,
  cmsUser: PropTypes.object,
  cmsUserCommunication: PropTypes.object,
  authInfoCommunication: PropTypes.object,
};

Dashboard.defaultProps = {
  location: {
    pathname: '',
  },
  token: '',
  logoutUser: () => {},
  t: () => {},
  history: {
    push: () => {},
  },
  getUserAuth: () => {},
  setSelectRole: () => {},
  getCmsUser: () => {},
  currentRoleSlug: '',
  cmsUser: {},
  cmsUserCommunication: {},
  authInfoCommunication: {},
};
